import { DeviceTypeRepository } from '@telespot/domain';

export interface RetrieveDeviceTypeOutput {
  id: string;
  name: string;
  version: string;
}

export interface IRetrieveDeviceTypeQuery {
  /**
   * Retrieves a single device type by id, projected to the fields needed by
   * the UI. Repository errors propagate so the caller can update its error
   * state.
   */
  execute(deviceTypeId: string): Promise<RetrieveDeviceTypeOutput>;
}

export class RetrieveDeviceTypeQuery implements IRetrieveDeviceTypeQuery {
  constructor(private readonly deviceTypeRepository: DeviceTypeRepository) {}

  public async execute(deviceTypeId: string): Promise<RetrieveDeviceTypeOutput> {
    const deviceType = await this.deviceTypeRepository.getById(deviceTypeId);
    return {
      id: deviceType.id,
      name: deviceType.name,
      version: deviceType.version,
    };
  }
}
